import { modelsProxyUrl } from "../../../../../API/axiosInstance";

// ─── Endpoints ─────────────────────────────────────────────────────────────────
export const SESSION_META_ENDPOINT = "/sessions/metadata";
export const SESSION_META_URL = modelsProxyUrl(SESSION_META_ENDPOINT);

export const POST_PAGE_SIZE = 10;

// Status codes where live SSE streaming is active.
// Per API docs: status 0 = Crawling Started, status 3 = Analysis Started
export const STREAMING_STATUSES = new Set([0, 3]);

// ─── Platform metadata ──────────────────────────────────────────────────────────
export const PLATFORM_ICONS = {
  facebook: "f",
  twitter: "𝕏",
  youtube: "▶",
  instagram: "◈",
  threads: "@",
  reddit: "r/",
};

export const PLATFORM_COLORS = {
  facebook:  { bg: "#1877F2", text: "#fff", light: "#EBF5FF" },
  twitter:   { bg: "#000000", text: "#fff", light: "#F0F0F0" },
  youtube:   { bg: "#FF0000", text: "#fff", light: "#FFF0F0" },
  instagram: { bg: "#E1306C", text: "#fff", light: "#FFF0F5" },
  threads:   { bg: "#000000", text: "#fff", light: "#F0F0F0" },
  reddit:    { bg: "#FF4500", text: "#fff", light: "#FFF3EE" },
};

export const DEFAULT_PLATFORM_COLOR = { bg: "#8B5CF6", text: "#fff", light: "#F3F0FF" };

// ─── Session status display config ────────────────────────────────────────────
export const STATUS_CFG = {
  "-3": { label: "Crawl Failed",    color: "#EF4444", bg: "rgba(239,68,68,0.08)",    pulse: false, dot: "#EF4444" },
  "-2": { label: "Analysis Failed", color: "#EF4444", bg: "rgba(239,68,68,0.08)",    pulse: false, dot: "#EF4444" },
   "0": { label: "Pending",         color: "#94A3B8", bg: "rgba(148,163,184,0.08)",  pulse: false, dot: "#94A3B8" },
   "1": { label: "Complete",        color: "#10B981", bg: "rgba(16,185,129,0.08)",   pulse: false, dot: "#10B981" },
   "2": { label: "Crawling",        color: "#F59E0B", bg: "rgba(245,158,11,0.08)",   pulse: true,  dot: "#F59E0B" },
   "3": { label: "Analysing",       color: "#8B5CF6", bg: "rgba(139,92,246,0.08)",   pulse: true,  dot: "#8B5CF6" },
   "4": { label: "Processing",      color: "#3B82F6", bg: "rgba(59,130,246,0.08)",   pulse: true,  dot: "#3B82F6" },
};

// Tab keys — used externally by the parent (SessionCard) to set initialTab
// "raw" | "processed"
export const TAB_KEYS = { RAW: "raw", PROCESSED: "processed" };
